// extracted by mini-css-extract-plugin
export default {"div":"Logo_div__RQm6+","logo":"Logo_logo__TCQyT","slide":"Logo_slide__qxq4C"};